import type { Place } from "./types";

const generic = /^(?:נקודה (?:על המפה|שנבחרה במפה)|נקודה שנבחרה|מיקום משותף|מיקום מהקישור|מיקום נבחר|מיקום נוכחי)$/;
const coordinates = /^\s*-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?\s*$/;
export function needsPlaceLabel(place: Place): boolean {
  return !place.name.trim() || generic.test(place.name.trim()) || coordinates.test(place.name);
}
export function namedPlace(place: Place): Place | null {
  if (!needsPlaceLabel(place)) return place;
  const address = place.address.trim();
  if (!address || coordinates.test(address) || generic.test(address) || address.startsWith("מיקום מהקישור")) return null;
  return { ...place, name: address };
}
